const handleConvertToDash = (text: string | null): string => {
  return text ? text : '-';
};

export { handleConvertToDash };
